import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import './Products.css';
import Productcard from '../../Components/Productcard/Productcard';

const categories = [
    { name: "all",          label: "All",          img: "" },
    { name: "Mug",          label: "Mug",          img: "/assets/categories/IMG_3112.JPG" },
    { name: "Bag Tag",      label: "Bag Tag",      img: "/assets/categories/547A4378.JPG" },
    { name: "Mouse Pad",    label: "Mouse Pad",    img: "/assets/categories/547A9131.JPG" },
    { name: "Money Bank",   label: "Money Bank",   img: "/assets/categories/547A4247.JPG" },
    { name: "Wall Decor",   label: "Wall Decor",   img: "/assets/categories/IMG_3067.JPG" },
    { name: "tote bag",     label: "Bags",         img: "/assets/categories/547a8909.JPG" },
    { name: "Mobile stand", label: "Mobile Stand", img: "" },
    { name: "Wall clock",   label: "Wall Clock",   img: "" },
    { name: "tumblers",     label: "Tumblers",     img: "/assets/categories/tumblers.jpeg" },
    { name: "Water bottle", label: "Water Bottle", img: "/assets/categories/water-bottles.jpeg" },
];

function Products() {
    const [allpro, setAllpro] = useState([]);
    const [pagination, setPagination] = useState({});
    const [loading, setLoading] = useState(false);
    const categoryFilterRef = useRef(null);

    const [searchParams, setSearchParams] = useSearchParams();
    const page = parseInt(searchParams.get("page") || 1);
    const category = searchParams.get("category") || "all";
    const limit = 20;

    useEffect(() => {
        setLoading(true);
        fetch(`https://pentadeco.in/api/products/${page}/${limit}/${category}`)
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    setAllpro(data.products);
                    setPagination(data.pagination);
                }
                setLoading(false);
            })
            .catch(err => { console.error(err); setLoading(false); });
    }, [page, category]);

    const handlePageChange = (newPage) => {
        searchParams.set("page", newPage);
        setSearchParams(searchParams);
    };

    const handleCategoryChange = (cat) => {
        searchParams.set("category", cat.toLowerCase());
        searchParams.set("page", 1);
        setSearchParams(searchParams);
    };

    return (
        <div className='main-products'>
            <h2 className="body-font-bold fs-4 mt-3 mb-4">
                All Products
                {pagination.totalItems != null && (
                    <span className="ms-2 text-muted" style={{fontSize:'0.85rem', fontWeight:500}}>({pagination.totalItems})</span>
                )}
            </h2>

            {/* Category filter */}
            <div className="categoryFilter mb-4" ref={categoryFilterRef}>
                {categories.map((cat, i) => (
                    <button
                        key={i}
                        className={`cat-filter-btn ${category === cat.name.toLowerCase() ? 'cat-active' : ''}`}
                        onClick={() => handleCategoryChange(cat.name)}
                    >
                        {cat.img && <img src={cat.img} alt={cat.label} />}
                        {cat.label}
                    </button>
                ))}
            </div>

            {/* Product grid */}
            {loading ? (
                <div className="products-loading">
                    <i className="fas fa-spinner fa-spin me-2"></i> Loading products...
                </div>
            ) : allpro?.length > 0 ? (
                <div className="row p-0 m-0">
                    {allpro.map((pro, ind) => (
                        <div key={ind} className="col-md-3 col-6 mb-3 p-1">
                            <Productcard
                                coverimg={pro.images[0]}
                                tag={pro.status}
                                saletxt={pro.spinningtxt}
                                name={pro.name}
                                price={pro.discountprice}
                                preprice={pro.price}
                                id={pro.proid}
                                admin={true}
                            />
                        </div>
                    ))}
                </div>
            ) : (
                <p className="text-center text-muted py-5">No products found</p>
            )}

            {/* Pagination */}
            {pagination.totalPages > 1 && (
                <div className="products-pagination">
                    <button
                        className="products-page-btn"
                        disabled={!pagination.isPrevious}
                        onClick={() => handlePageChange(pagination.prevPage)}
                    >
                        <i className="fi fi-ss-angle-left" style={{position:'relative', bottom:'-2px'}}></i>
                    </button>
                    <span className="products-page-info">
                        Page {pagination.currentPage} of {pagination.totalPages}
                    </span>
                    <button
                        className="products-page-btn"
                        disabled={!pagination.isNext}
                        onClick={() => handlePageChange(pagination.nextPage)}
                    >
                        <i className="fi fi-ss-angle-right" style={{position:'relative', bottom:'-2px'}}></i>
                    </button>
                </div>
            )}
        </div>
    );
}

export default Products;
